// extracted by mini-css-extract-plugin
export default {"controls":"CommentEdit_controls__roGRW","field":"CommentEdit_field__XQLIg"};